import React from "react";

class Verification extends React.Component {
  constructor(props) {
    super(props);
  }

  renderOtpInputs = (className, handleInputChange, otp, otpLength, otpExpired) =>
    Array.from({ length: otpLength }).map((_, idx) => (
      <input
        key={idx}
        type="text"
        className={className}
        // disabled={otpExpired} 
        value={otp[idx]}
        maxLength={1}
        onInput={(e) => {
          // if (otpExpired) return; 

          if (!/^\d*$/.test(e.target.value)) {
            e.target.value = e.target.value.replace(/\D/g, "");
          }
          handleInputChange(idx, e.target.value);

          if (e.target.nextSibling && e.target.value) {
            e.target.nextSibling.focus();
          }
        }}
        onKeyDown={(e) => {
          // if (otpExpired) return;
          if (e.key === "Backspace" && !e.target.value && e.target.previousSibling) {
            e.target.previousSibling.focus();
            handleInputChange(idx - 1, "");
          }
        }}
        onPaste={(e) => {
          // if (otpExpired) return; 
          e.preventDefault();
          const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
          if (!pasted) return;

          const newOtp = [...otp];
          for (let i = 0; i < otpLength; i++) {
            newOtp[i] = pasted[i] || "";
          }
          handleInputChange(null, newOtp);
        }}
      />
    ));

  render() {
    const {
      email,
      otp,
      otpExpired,
      timer,
      handleInputChange,
      handleChangeStep,
      onOtpSend,
      otpError,
      otpLength,
      styles,
      resendOtp,
      loading
    } = this.props;

    return (
      <div className={styles.email_otp}>
        <div className={styles.email_otp__background}>
          <div className={styles.email_otp__content}>

            <div className={styles.email_otp__form_header}>
              <div className={styles.email_otp__icon}>
                <img src="/images/mail.svg" alt="mail" />
              </div>
              <h2 className={styles.email_otp__form_title}>Check your email</h2>
              <p className={styles.email_otp__form_description}>
                We’ve just sent your email verification code to{" "}
                <span className={styles.highlight}>{email}</span>
              </p>
            </div>

            <div className={styles.email_otp__otp_main_container}>
              <div className={styles.email_otp__otp_container}>
                {this.renderOtpInputs(
                  styles.otp_input,
                  handleInputChange,
                  otp,
                  otpLength,
                  otpExpired
                )}
              </div>

              {otpError && <div className={styles.email_otp_error}>{otpError}</div>}

              <div className={styles.email_otp__submit_container}>
                <button
                  className={`${styles.email_otp__submit_btn} ${
                    otp.some((digit) => digit === "")
                      ? styles.email_otp__submit_btn_disabled
                      : ""
                  } ${loading ? "loading" : ""}`}
                  onClick={onOtpSend}
                  disabled={otp.some((digit) => digit === "")}
                >
                  Verify OTP
                </button>
              </div>

              <div className={styles.email_otp__footer}>
                <span
                  className={styles.email_otp__change_email}
                  onClick={() => handleChangeStep("changeEmail")}
                >
                  Change email
                </span>

                <p className={styles.email_otp__timer}>
                  OTP code expired in {" "}
                  <span className={styles.email_otp__timer_count}>
                    {timer}
                  </span>

                  <span
                    className={
                      otpExpired
                        ? styles.email_otp__resend_enabled
                        : styles.email_otp__resend_disabled
                    }
                    onClick={() => otpExpired && resendOtp("resend_otp")}
                  >
                    Resend OTP code
                  </span>
                </p>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Verification;
